module.exports = __webpack_public_path__ + "img/camera-circle.aa711691.png";